<template>
  <div class="all">
    <SideControls />
    <div class="visualizers" v-if="visualizers && visualizers.length">
      <div>Visualizers</div>
      <input
        type="text"
        class="search"
        v-model="search"
        placeholder="Search Visualizers..."
      />
      <div
        v-for="(visualizer, index) in filteredVisualizers"
        :key="index"
        class="visualizerLink"
      >
        <span> {{ index }} </span>
        <router-link :to="`/visualizer/${visualizer._id}`">{{
          visualizer.title ? visualizer.title : visualizer._id
        }}</router-link>
      </div>
      <button class="action" @click="createNewVisualizer">
        + New Visualizer
      </button>
    </div>
  </div>
</template>

<script>
import { getAllVisualizers, createNewVisualizer } from "./VisualizerHelpers";
import SideControls from "../../components/SideControls";

export default {
  name: "AllVisualizers",
  async created() {
    this.visualizers = await getAllVisualizers();
  },
  data() {
    return {
      visualizers: null,
      search: "",
    };
  },
  computed: {
    filteredVisualizers() {
      return this.visualizers.filter((visualizer) => {
        if (visualizer.title) {
          return visualizer.title
            .toLowerCase()
            .includes(this.search.toLowerCase());
        } else {
          return "";
        }
      });
    },
  },
  components: {
    SideControls,
  },
  methods: {
    async createNewVisualizer() {
      const visualizerId = await createNewVisualizer();
      this.$router.push(`/visualizer/${visualizerId}`);
    },
  },
};
</script>

<style scoped>
.all {
  display: flex;
  position: relative;
  height: calc(100vh - 36px);
}
.visualizers {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 450px;
}
.visualizerLink {
  padding: 5px;
  background-color: #f7f7f7;
  margin-bottom: 5px;
  margin-top: 5px;
}

.action {
  cursor: pointer;
  margin-top: 10px;
}
.search {
  margin-bottom: 10px;
  margin-top: 5px;
}
</style>